import { toast } from "react-toastify";
import moment from "moment";
import { axiosInstance, axiosInstanceAuth } from "../../../Utils/AxiosInstance";
import { storage } from "../../../Utils/storageService";

export const getCashBookData = (data) => ({
  type: "GET_CASH_BOOK_DATA",
  payload: data,
});

export const fetchCashBookData = ({ From, To, ProjectId, AccountId }) => {
  return async (dispatch) => {
    dispatch(getCashBookData({ loading: true, error: null }));
    try {
      const payload = {
        From,
        To,
        ProjectId: ProjectId || null,
        Id: AccountId || 0,
      };
      const response = await axiosInstance.post("Reports/CashBook", payload);

      if (response?.data?.IsSuccess === true) {
        const cashInHand = response?.data?.Data?.CashBalance;
        const openingBalance = response?.data?.Data?.OpeningBalance;
        const cashAccounts = response?.data?.Data?.CashAccounts;
        let credit = 0;
        let debit = 0;
        const arr = (response?.data?.Data?.TransactionList || []).filter((val) => val != null);

        arr.forEach((val) => {
          if (val.TransactionType === "CREDIT") {
            credit += parseFloat(val.Amount);
          } else {
            debit += parseFloat(val.Amount);
          }
        });

        dispatch(
          getCashBookData({
            loading: false,
            data: arr,
            cashInHand,
            openingBalance,
            cashAccounts,
            credit,
            debit,
            error: null,
          }),
        );
      } else {
        dispatch(
          getCashBookData({
            loading: false,
            error: response.data.Message || "Failed to fetch cashbook data",
          }),
        );
      }
    } catch (error) {
      dispatch(getCashBookData({ loading: false, error: error.message }));
    }
  };
};

export const getcustomerledger = (data) => ({
  type: "CUSTOMER_LEDGER",
  payload: data,
});

export const fetchCustomerLedger = (data) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}Reports/CustomerLedger`,
        data,
      );

      if (response.data.IsSuccess) {
        const data = response.data.Data;

        let credit = 0;
        let debit = 0;

        data.forEach((val) => {
          if (val.TransactionType === "CREDIT") {
            credit += parseFloat(val.Amount);
          } else if (val.TransactionType === "DEBIT") {
            debit += parseFloat(val.Amount);
          }
        });

        dispatch(
          getcustomerledger({
            loading: false,
            ledgerData: data,
            credit,
            debit,
            error: null,
          }),
        );
      }
    } catch (error) {
      dispatch(
        getcustomerledger({
          loading: false,
          ledgerData: [],
          credit: 0,
          debit: 0,
          error: error.message,
        }),
      );
    }
  };
};

export const getgeneralledger = (data) => ({
  type: "GENERAL_LEDGER",
  payload: data,
});

// Clears the transaction-drilldown slice left over from a previous visit, so reopening the
// Ledger page never briefly shows another account's popup data before anything is selected.
export const resetGeneralLedger = () => ({
  type: "RESET_GENERAL_LEDGER",
});

// realProjectsOnly: set by the Main Chart of Account ledger, which has no single project —
// drops each voucher's global-mirror (ProjectId == null) copy of every line, which would
// otherwise show every line twice.
export const fetchGeneralLedgerTransactions = (id, type, projectId, realProjectsOnly = false) => {
  return async (dispatch) => {
    dispatch(getgeneralledger({ loading: true, error: null }));
    try {
      // projectId omitted (undefined) -> default to the globally active project (existing
      // behavior). projectId explicitly passed as null -> no project filter, backend returns
      // every project this voucher touched (needed for cross-project Gatepass entries).
      const resolvedProjectId =
        projectId !== undefined ? projectId : storage.getProjectId() || null;
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}Reports/GeneralLedgerTransactions`,
        {
          params: {
            projectid: resolvedProjectId,
            VoucherId: id,
            voucherType: type,
            ...(realProjectsOnly ? { realProjectsOnly: true } : {}),
          },
        },
      );

      if (response.data.IsSuccess) {
        const data = response.data.Data;

        let DebitAmount = 0;
        let CreditAmount = 0;

        data.forEach((item) => {
          if (item.TransactionType === "DEBIT") {
            DebitAmount += item.Amount;
          } else if (item.TransactionType === "CREDIT") {
            CreditAmount += item.Amount;
          }
        });

        dispatch(
          getgeneralledger({
            loading: false,
            transactionData: data,
            transactionDebitTotal: DebitAmount,
            transactionCreditTotal: CreditAmount,
            error: null,
          }),
        );
      }
    } catch (error) {
      dispatch(
        getgeneralledger({
          loading: false,
          transactionData: [],
          transactionDebitTotal: 0,
          transactionCreditTotal: 0,
          error: error.message,
        }),
      );
    }
  };
};

export const getGeneralLedgerData = (data) => ({
  type: "GENERAL_LEDGER_DATA",
  payload: data,
});

// Clears the previously loaded ledger (account, dates, rows, totals) left over in Redux from
// the last visit, so reopening the Ledger page never shows stale data before an account/date
// range is chosen this time.
export const resetGeneralLedgerData = () => ({
  type: "RESET_GENERAL_LEDGER_DATA",
});

export const fetchGeneralLedger = (data) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}Reports/GeneralLedger`,
        data,
      );

      if (response.data.IsSuccess) {
        const res = response.data;

        let credit = 0;
        let debit = 0;

        res.Data.forEach((val) => {
          if (val.TransactionType === "CREDIT") {
            credit += parseFloat(val.Amount);
          } else if (val.TransactionType === "DEBIT") {
            debit += parseFloat(val.Amount);
          }
        });

        dispatch(
          getGeneralLedgerData({
            loading: false,
            ledgerData: res.Data,
            account: res.Account,
            accountTitle: res.Accounttitle,
            to: res.To,
            from: res.From,
            openingBalanceType: res.OpeningBalanceType,
            openingBalance: res.OpeningBalance,
            openingBalanceDate: res.OpeningBalanceDate,
            credit,
            debit,
            error: null,
          }),
        );
      }
    } catch (error) {
      dispatch(
        getGeneralLedgerData({
          loading: false,
          error: error.message,
        }),
      );
    }
  };
};

export const getInstallmentRecovery = (data) => ({
  type: "INSTALLMENT_RECOVERY",
  payload: data,
});

export const getBankBalanceReport = (data) => ({
  type: "GET_BANK_BALANCE_REPORT",
  payload: data,
});

export const fetchBankBalanceReport = ({ From, To, ProjectId, AccountId }) => {
  return async (dispatch) => {
    dispatch(getBankBalanceReport({ loading: true, error: null }));
    try {
      const payload = {
        From,
        To,
        ProjectId: ProjectId || null,
        Id: AccountId || 0,
      };
      const response = await axiosInstance.post("Reports/BankBalance", payload);

      if (response?.data?.IsSuccess === true) {
        const resData = response?.data?.Data;
        const bankBalance = resData?.BankBalance || 0;
        const openingBalance = resData?.OpeningBalance || 0;
        const bankAccounts = resData?.BankAccounts || [];
        let credit = 0;
        let debit = 0;
        const arr = (resData?.TransactionList || []).filter((val) => val != null);

        arr.forEach((val) => {
          if (val.TransactionType === "CREDIT") {
            credit += parseFloat(val.Amount);
          } else {
            debit += parseFloat(val.Amount);
          }
        });

        dispatch(
          getBankBalanceReport({
            loading: false,
            data: arr,
            bankBalance,
            openingBalance,
            bankAccounts,
            credit,
            debit,
            error: null,
          }),
        );
      } else {
        dispatch(
          getBankBalanceReport({
            loading: false,
            error: response?.data?.Message || "Failed to fetch bank balance.",
          }),
        );
      }
    } catch (error) {
      dispatch(
        getBankBalanceReport({
          loading: false,
          error: error.message,
        }),
      );
    }
  };
};

export const fetchInstallmentRecovery = ({ start, end }) => {
  return async (dispatch) => {
    dispatch(getInstallmentRecovery({ loading: true, error: null }));
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}Reports/InstallmentsRecoveryNew`,
        {
          params: {
            ProjectId: storage.getProjectId() || "",
            StartDate: start,
            EndDate: end,
          },
        },
      );

      if (response.data?.IsSuccess) {
        const res = response.data;

        dispatch(
          getInstallmentRecovery({
            loading: false,
            recovery: res.Recovery || [],
            totalDue: res.TotalDueAmount || 0,
            totalReceived: res.TotalReceivedAmount || 0,
            totalReceivable: res.TotalReceivable || 0,
            error: null,
          }),
        );
      }
    } catch (error) {
      dispatch(
        getInstallmentRecovery({
          loading: false,
          error: error.message,
        }),
      );
    }
  };
};

export const getReserveCommissionPayable = (data) => ({
  type: "RESERVE_COMMISSION_PAYABLE",
  payload: data,
});

export const fetchReserveCommissionPayable = (data) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}Reports/ReserveCommissionPayable`,
        data,
      );

      const res = response.data;

      if (res?.IsSuccess) {
        dispatch(
          getReserveCommissionPayable({
            loading: false,
            data: res.Data || [],
            error: null,
          }),
        );
      }
    } catch (error) {
      dispatch(
        getReserveCommissionPayable({
          loading: false,
          data: [],
          error: error.message,
        }),
      );
    }
  };
};

export const getTrialBalance = (data) => ({
  type: "TRIAL_BALANCE",
  payload: data,
});

export const fetchTrialBalance = (data) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}Reports/TrailBalance`,
        data,
      );

      const res = response.data;

      if (res?.IsSuccess) {
        const credit = res.Data.reduce((acc, val) => acc + parseFloat(val.Credit), 0);
        const debit = res.Data.reduce((acc, val) => acc + parseFloat(val.Debit), 0);

        let debitGrandTotal = 0;
        let creditGrandTotal = 0;
        let closingDebittotal = 0;
        let openingDebittotal = 0;
        let openingCredittotal = 0;
        let closingCredittotal = 0;

        res.Data.forEach((val) => {
          debitGrandTotal += parseFloat(val.Debit);
          creditGrandTotal += parseFloat(val.Credit);
          openingDebittotal += parseFloat(val.OpeningDebit);
          closingDebittotal += parseFloat(val.ClosingDebit);
          openingCredittotal += parseFloat(val.OpeningCredit);
          closingCredittotal += parseFloat(val.ClosingCredit);
        });

        dispatch(
          getTrialBalance({
            loading: false,
            data: res.Data,
            credit,
            debit,
            debitGrandTotal,
            creditGrandTotal,
            openingDebittotal,
            closingDebittotal,
            openingCredittotal,
            closingCredittotal,
            error: null,
          }),
        );
      }
    } catch (error) {
      dispatch(
        getTrialBalance({
          loading: false,
          data: [],
          error: error.message,
        }),
      );
    }
  };
};

export const setGeneralJournalData = (data, summary) => ({
  type: "SET_GENERAL_JOURNAL_DATA",
  payload: {
    entries: data,
    summary,
  },
});

export const fetchGeneralJournalData = ({ From, To }) => {
  return async (dispatch) => {
    try {
      const projectId = storage.getProjectId();

      const payload = {
        From,
        To,
        ProjectId: projectId || null,
      };

      const response = await axiosInstance.post("Reports/GeneralJournal", JSON.stringify(payload), {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.data.IsSuccess === true) {
        const data = response.data.Data;

        let credit = 0;
        let debit = 0;

        data.forEach((val) => {
          if (val.Debit === "") {
            credit += parseFloat(val.Credit);
          } else {
            debit += parseFloat(val.Debit);
          }
        });

        dispatch(setGeneralJournalData(data, { credit, debit }));
      } else {
        toast.error(response.data.Message || "No journal data found.");
      }
    } catch (error) {
      toast.error("Something went wrong while fetching general journal data.");
      console.error("GeneralJournal API error:", error);
    }
  };
};

export const setCommissionReceiptsData = (data) => ({
  type: "SET_COMMISSION_RECEIPTS_DATA",
  payload: data,
});

export const fetchCommissionReceiptsData = ({ From, To }) => {
  return async (dispatch) => {
    try {
      const projectId = storage.getProjectId();

      const payload =
        From && To
          ? {
              From: moment(From).format("YYYY-MM-DD"),
              To: moment(To).format("YYYY-MM-DD"),
              ProjectId: projectId || null,
            }
          : {
              ProjectId: projectId || null,
            };

      const response = await axiosInstance.post(
        "Reports/CommissionReceipts",
        JSON.stringify(payload),
      );

      if (response.data.IsSuccess === true) {
        dispatch(setCommissionReceiptsData(response.data.Data));
      } else {
        toast.error(response.data.Message || "No data found.");
      }
    } catch (error) {
      toast.error("Something went wrong while fetching commission receipts.");
      console.error("CommissionReceipts API error:", error);
    }
  };
};

export const getWaHistory = (data) => ({
  type: "WHATSAPP_HISTORY",
  payload: data,
});

export const fetchWaHistory = ({ start, end }) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstanceAuth.get(
        `/Whatsapp/GetWhatsappMessages?module=ERP&from=${start}&to=${end}`,
      );
      if (response.data.IsSuccess === true) {
        dispatch(
          getWaHistory({
            data: response.data.Data,
            loading: false,
            error: null,
          }),
        );
      } else {
        toast.error(response.data.Message || "No data found.");
        dispatch(
          getWaHistory({
            loading: false,
            error: response.data.Message || "No data found.",
          }),
        );
      }
    } catch (error) {
      dispatch(
        getWaHistory({
          loading: false,
          error: error.message,
        }),
      );
    }
  };
};
export const fetchWaMesgDetail = async (id) => {
  try {
    const response = await axiosInstanceAuth.get(`/Whatsapp/GetWhatsappMessageDetail?id=${id}`);
    if (response.data.IsSuccess === true) {
      return response.data;
    } else {
      toast.error(response.data.Message || "No data found.");
      return {
        loading: false,
        Error: response.data.Message || "No data found.",
      };
    }
  } catch (error) {
    return {
      loading: false,
      Error: error.message,
    };
  }
};

export const GetCustomerReport = (data, loading) => {
  return {
    type: "get_customerreport",
    payload: data,
    loading,
  };
};
export function getcustomerreport(data) {
  return async (dispatch) => {
    try {
      const pgurl = `Reports/Customer/Unit?ProjectId=${data?.projectId}&CustomerCnic=${data?.cnic}`;
      //   dispatch(GetCustomerReport(null, true));

      const result = await axiosInstance.get(pgurl);

      if (result.data.IsSuccess === true) {
        dispatch(GetCustomerReport(result.data.Data, false));
      } else {
        toast.error(result.data.Message);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
}
